import { Injectable } from "@angular/core";
import {
  NotificationMessageIcon
} from "@app/framework/notification-sidebar/notification-sidebar.component";
import { environment } from "@env/environment";
import { HttpUtilService } from "@services/http-util.service";
import { NotificationsService } from "@services/notifications.service";
import { TranslationService } from "@services/translation.service";
import { WebsocketService } from "@services/websocket.service";
import { Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CopyDataService {
  public foldersToZip = {};
  constructor(
    private notifications: NotificationsService,
    public websocketService: WebsocketService,
    public http: HttpUtilService,
    private translationService:TranslationService
  ) { }
  initCopySocket(sourceId) {
    let resp = new Subject();
    let copyId = sourceId + Date.now();
    const socket = this.websocketService.createSocket();
    socket.onopen = (data) => {
      socket.send(
        JSON.stringify({
          action: "setlistener",
          data: {
            type: "data",
            "user-pool-id": environment.cognitoUserPoolId,
            "client-id": environment.cognitoClientId,
            "sub-domain": environment.domain,
          },
        })
      );
    };

    socket.onmessage = (event) => {
      const data = event.data.replace(/'/g, '"');
      const message = JSON.parse(data);
      if (message?.Status === "Listener set.") {
        resp.next(message["Connection"]);
        resp.complete();
        return;
      }

      if (message?.Status === "initial connnection") {
        this.notifications.addUserNotification(
          {
            text: this.translationService.getTranslatedContent('copy_started_from',"Copy Started from") +": <strong>" + message.item + "<strong>",
            preventRemoval: true,
            icon: NotificationMessageIcon.fileExport,
            shouldForceOpen: true
            
          },
          copyId
        );
        return;
      }
      if (message?.course) {
        this.notifications.addUserNotification(
          {

            text: this.translationService.getTranslatedContent('copy_finished',"Copy Finished")+" : <strong>" + message.course.title + "<strong>",
            preventRemoval: false,
            icon: NotificationMessageIcon.checkmark,
            link: { text: "Open", href: `${message.course.type}/${message.course.id}` }
          },
          copyId
        );
        return
      }
      if (message?.error || !message) {
        this.notifications.addUserNotification(
          {
            text:this.translationService.getTranslatedContent('an_error_occured_during_the_copy',"An error occured during the copy"),
            preventRemoval: false,
            icon: NotificationMessageIcon.fail,
          },
          copyId
        );
      }
    };

    socket.onerror = (error) => {
      this.notifications.addUserNotification(
        {
          text: this.translationService.getTranslatedContent('an_error_occured_during_the_copy',"An error occured during the copy"),
          preventRemoval: false,
          icon: NotificationMessageIcon.fileZip,
        },
        copyId
      );
    };

    return resp.asObservable();
  }



}
